import { render, staticRenderFns } from "./ChangelogView.vue?vue&type=template&id=200ab822&scoped=true"
import script from "./ChangelogView.vue?vue&type=script&lang=js"
export * from "./ChangelogView.vue?vue&type=script&lang=js"
import style0 from "./ChangelogView.vue?vue&type=style&index=0&id=200ab822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200ab822",
  null
  
)

export default component.exports